import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type ProfileName = {
  profileName: string;
  dfn: string;
  deleted: string | null;
  officeDenotation?: string;
};

export function ProfileName({ profileName, dfn, deleted, officeDenotation }: ProfileName) {
  const { t } = useSonTranslation('glossary');
  return (
    <p>
      <dfn className="invisible">{dfn}: </dfn>
      <strong className="font-bold-15-19">
        {profileName} {deleted ? ` (${deleted})` : null}
      </strong>
      {officeDenotation
        ? (
            <>
              <dfn className="invisible">{t('officeDenotation')}:</dfn>
              <span> ({officeDenotation})</span>
            </>
          )
        : null}
    </p>
  );
}
